export default "__VITE_ASSET__CjLFHny6__"